export default __webpack_public_path__ + "static/media/artgallery.5aa47998.png";